import moment, { Moment } from 'moment';
import { typedAction } from 'store/modules/base';
import {
  FuncaoInternaParticipante,
  FuncaoParticipante,
  GrupoAcesso,
  ModuloUsuarioResponse,
  Modulos,
  Perfil,
  TipoAcessoParticipante,
} from 'common/genericTypes';

const mockedModuloFuncao: Array<ModuloUsuarioResponse> = [
  {
    id: 1,
    nomeEnum: Modulos.INSTRUMENTO_FINANCEIRO,
    nome: '',
  },
];

const mockedParticipante: Participante = {
  id: '',
  razaoSocial: '',
  cnpj: '',
  dataCriacao: moment(),
  tipoAcesso: TipoAcessoParticipante.Participante,
  funcao: FuncaoParticipante.Custodiante,
  perfil: Perfil.Escrita,
};

const mockedUsuario: Usuario = {
  id: '',
  nome: '',
  email: '',
  dataCriacao: moment(),
  grupoAcesso: GrupoAcesso.Comum,
  participante: mockedParticipante,
  modulos: mockedModuloFuncao,
  participanteFuncaoUsuarioId: '',
};

interface Usuario {
  id: string;
  nome: string;
  email: string;
  dataCriacao: Moment;
  participante: Participante;
  participanteFuncaoUsuarioId: string;
  grupoAcesso: GrupoAcesso;
  modulos: Array<ModuloUsuarioResponse>;
}

interface Participante {
  id: string;
  razaoSocial: string;
  cnpj: string;
  dataCriacao: Moment;
  tipoAcesso: TipoAcessoParticipante | 'DEPOSITARIA';
  funcao: FuncaoParticipante | FuncaoInternaParticipante;
  perfil: Perfil;
}

export interface AuthState {
  isAuth: boolean;
  usuario: Usuario;
  globalToken: string;
  token: string;
}

export interface AuthPayload {
  usuario: Usuario;
  token: string;
}

export const loginAuth = (payload: AuthPayload) => {
  return typedAction('auth/LOGINAuth', payload);
};

export const login = (payload: AuthPayload) => {
  return typedAction('auth/LOGIN', payload);
};

export const logout = () => {
  return typedAction('auth/LOGOUT');
};

export const loginAutomatico = () => {
  return typedAction('auth/AUTOMATICO');
};

export const saveModulos = (payload: Usuario) => {
  return typedAction('auth/FUNCOES', payload);
};

type OperationAction = ReturnType<
  typeof loginAuth | typeof login | typeof logout | typeof loginAutomatico | typeof saveModulos
>;

const getUsuarioFromSessionState = () => {
  const usuarioString = sessionStorage.getItem('usuario');
  if (!usuarioString) return mockedUsuario;

  return JSON.parse(usuarioString) as Usuario;
};

const initialState: AuthState = {
  isAuth: !!sessionStorage.getItem('jwtToken'),
  usuario: getUsuarioFromSessionState(),
  token: sessionStorage.getItem('jwtToken') ?? '',
  globalToken: sessionStorage.getItem('globalJwtToken') ?? '',
};

export function authReducer(
  state: AuthState = {
    ...initialState,
  },
  action: OperationAction
): AuthState {
  switch (action.type) {
    case 'auth/LOGIN':
      const token = action.payload.token;
      sessionStorage.setItem('jwtToken', token);
      sessionStorage.setItem('usuario', JSON.stringify(action.payload.usuario));
      return {
        ...state,
        isAuth: !!token,
        usuario: action.payload.usuario,
        token: token,
      };
    case 'auth/LOGINAuth':
      sessionStorage.setItem('globalJwtToken', action.payload.token);
      return {
        ...state,
        globalToken: action.payload.token,
      };
    case 'auth/LOGOUT':
      sessionStorage.removeItem('jwtToken');
      sessionStorage.removeItem('globalJwtToken');
      sessionStorage.removeItem('usuario');
      sessionStorage.removeItem('idpToken');
      return { ...initialState, isAuth: false };
    case 'auth/AUTOMATICO':
      return { ...state, isAuth: true };
    case 'auth/FUNCOES':
      sessionStorage.setItem('usuario', JSON.stringify(action.payload));
      return {
        ...state,
        usuario: {
          ...state.usuario,
          modulos: action.payload.modulos,
        },
      };
    default:
      return state;
  }
}
